export const STANDALONE_ONBOARDING_IMAGE =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/26b30dae53abfba95d356ec3b51f7340-1755187924602/routing.png';
